var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import Select from "react-select";
import "./optionField.styles.scss";
import "antd-mobile/dist/antd-mobile.css";
import { Picker as ANT_Picker } from "antd-mobile";
import Helpers from "../../utils/helpers";
var OptionField = function (props) {
    var label = props.label, required = props.required, isMobile = props.isMobile;
    var _a = React.useState(false), visible = _a[0], toggleVisibility = _a[1];
    var onVisibilityChange = function (visibility) {
        return toggleVisibility(visibility);
    };
    return (React.createElement("div", { className: "option-field-container" },
        label && (React.createElement("label", { className: "label" },
            label,
            React.createElement("span", { className: "required-indicator" }, required ? "*" : ""))),
        isMobile ? (React.createElement(Picker, __assign({ onVisibleChange: onVisibilityChange, pickerVisible: visible }, props))) : (React.createElement(Select, __assign({}, props, { className: "option-select-container", classNamePrefix: "react-select" })))));
};
export var Picker = function (props) {
    var onChange = props.onChange, options = props.options, selectedOptionLabel = props.selectedOptionLabel, cols = props.cols, onOkText = props.onOkText, dismissText = props.dismissText, onVisibleChange = props.onVisibleChange, pickerVisible = props.pickerVisible, value = props.value, showIndicator = props.showIndicator, placeholder = props.placeholder;
    var onPickerValueSelect = function (val) {
        var selected = Helpers.getOptionWithValue(options, val[0]);
        onChange && onChange(selected);
    };
    return (React.createElement("div", { className: "pndr-mobile__picker" },
        React.createElement(ANT_Picker, { cols: cols ? cols : 1, data: options, okText: onOkText || "Select", dismissText: dismissText || "Dismiss", extra: "pndr-picker", onOk: onPickerValueSelect, onVisibleChange: onVisibleChange, value: value && [value.value] },
            React.createElement("button", { className: "selected-option " + (pickerVisible ? "visible" : "") },
                selectedOptionLabel && (React.createElement("span", { className: "selected-option-text" }, selectedOptionLabel)),
                !selectedOptionLabel && (React.createElement("span", { className: "placeholder" }, placeholder ? placeholder : "Select")),
                showIndicator && (React.createElement("span", { className: "indicator" },
                    React.createElement("i", { className: "fas fa-chevron-" + (pickerVisible ? "up" : "down") }))),
                " "))));
};
export default OptionField;
//# sourceMappingURL=optionField.js.map